import { mapActions, mapState } from "vuex"
import dayjs from 'dayjs';

export default {
	components: {},
	filters: {
		formatDate(value) {
			return dayjs(value).format('DD.MM.YYYY HH:mm:ss');
		}
	},
	data() {
		return {
			deleteConfirm: false,
			selectedItem: null,
			columns: [
				{
					label: 'Контрагент',
					prop: 'name'
				},
				{
					label: '№ договору',
					prop: 'contractNumber'
				},
				{
					label: 'Код ЄДРПОУ/ІПН',
					prop: 'code'
				},
				{
					label: 'Email',
					prop: 'email',
				},
				{
					label: 'Доданий',
					prop: 'date',
				},

			],
			limit: 20,
			offset: 0,
			currentPage: 1,
		}
	},
	computed: {
		...mapState({
			users: state => state.Users.users,
			total: (state) => state.Users.total,
			loading: state => state.Users.loading,
		})
	},
	methods: {
		...mapActions(['getAllUsers', 'deleteUser', 'setCurrentCompany', 'setCurrentUser']),
		indexMethod(index) {
			if (this.currentPage === 1) {
				return index;
			}
			return index + this.offset;
		},
		loginAsUser(data) {
			this.setCurrentCompany(data);
			this.setCurrentUser(data._id);
			this.$router.push('/accruals');
		},
		openConfirmDelete(data) {
			this.deleteConfirm = true;
			this.selectedItem = data;
		},
		async handleDelete() {
			await this.deleteUser({
				id: this.selectedItem._id
			}).then(() => {
				this.getAllUsers({ limit: this.limit, offset: this.offset });
				this.deleteConfirm = false;
			}).catch(e => console.log(e))
		}
	},
	watch: {
		currentPage(val) {
			this.offset = this.limit * val - this.limit;
			this.getAllUsers({ limit: this.limit, offset: this.offset });
		}
	},
	beforeMount() {
		this.getAllUsers({ limit: this.limit, offset: this.offset });
	}
}